import * as actions from './shipmentPartner/actions'
import * as mutations from './shipmentPartner/mutations'
import * as getters from './shipmentPartner/getters'

import { dataProps } from './shipmentPartner/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/shipmentPartner.js